import { AlertTriangle, RotateCcw } from "lucide-react";

interface AnalysisErrorProps {
  readonly detail: string;
  readonly onRetry: () => void;
}

export function AnalysisError({ detail, onRetry }: AnalysisErrorProps) {
  return (
    <section role="alert" className="rounded-xl border border-negative/35 bg-negative/5 p-5 shadow-lg" data-testid="analysis-error">
      <div className="flex items-start gap-3">
        <AlertTriangle aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-negative" />
        <div>
          <h2 className="text-base font-bold text-primary">Analysis request failed</h2>
          <p className="mt-1 text-sm leading-relaxed text-secondary">{detail}</p>
          <button type="button" onClick={onRetry} className="secondary-button mt-4">
            <RotateCcw aria-hidden="true" className="h-4 w-4" />
            Retry analysis
          </button>
        </div>
      </div>
    </section>
  );
}
